import { render, staticRenderFns } from "./ActivationEmailList.vue?vue&type=template&id=c01848e0&scoped=true&"
import script from "./ActivationEmailList.vue?vue&type=script&lang=ts&"
export * from "./ActivationEmailList.vue?vue&type=script&lang=ts&"
import style0 from "./ActivationEmailList.vue?vue&type=style&index=0&id=c01848e0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c01848e0",
  null
  
)

export default component.exports